import { render, staticRenderFns } from "./PRMajor.vue?vue&type=template&id=53e192a6&scoped=true&"
import script from "./PRMajor.vue?vue&type=script&lang=js&"
export * from "./PRMajor.vue?vue&type=script&lang=js&"
import style0 from "./PRMajor.vue?vue&type=style&index=0&id=53e192a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e192a6",
  null
  
)

export default component.exports